$(document).ready(function() {
    let ajaxPathTagReport = "/action/report/tag";
    let ajaxPathGetTagReport = ajaxPathTagReport + '/tag-report';
    let ajaxPathGetTagReportFavoriteListItems = ajaxPathTagReport + '/favorite/list-items';
    let ajaxPathSaveTagReportFavorite = ajaxPathTagReport + '/favorite/save';
    let ajaxPathGetForm = ajaxPathTagReport + '/form/';
    let excelExportURL = "/action/report/excel/tag-report";

    let ajaxLockActive = false;

    activateTagSelects();
    activateFlatpickr();

    $(document).on('click', 'div#tag_report_wrapper button#show_tag_report', function () {
        getTagReport();
    });

    $(document).on('click', 'div#tag_report_wrapper button#open_save_tag_report_favorite_modal', function () {
        showFavoriteModal();
    });

    $(document).on('click', 'div#save_tag_report_favorite_modal [data-tag-report-modal-close]', function (e) {
        e.preventDefault();
        hideFavoriteModal();
    });

    $(document).on('click', 'div#tag_report_wrapper a#tag-report-excel-export-button', function () {
        createExcelFile();
        return false;
    });

    $(document).on('click', 'div#tag_report_wrapper div#tag_report_content tr.tr_product_group_tag td, ' +
        'div#tag_report_wrapper div#tag_report_content tr.tr_product_tag td', function () {
        // Toggle this tags product details
        let tagId = $(this).closest('tr').attr('tag_id');
        $('tr[parent_tag_id="' + tagId + '"]').each(function() {
            $(this).toggle();
        });
    });

    $(document).on('click', 'div#tag_report_wrapper div#save_tag_report_favorite_modal button#save_tag_report_favorite', function () {
        saveTagReportFavorite();
    });

    $(document).on('click', 'div#tag_report_wrapper a.tag_report_favorite_list_item', function () {
        let tagReportFavoriteId = parseInt($(this).attr('tag_report_favorite_id'), 10) || 0;

        if (tagReportFavoriteId <= 0) {
            return false;
        }

        if (typeof setActiveListItem === 'function') {
            setActiveListItem('div#tag_report_wrapper .tag_report_favorite_list_item', tagReportFavoriteId, 'tag_report_favorite_id');
        }

        getFormWithFavoriteSelected(tagReportFavoriteId);
        return false;
    });

    $(document).on('click', 'div#tag_report_wrapper input[name="display_deactivated"]', function(){
        refreshList();
    });

    $(document).on('keyup', 'div#tag_report_wrapper div#tag_favorites_list_wrapper input#favorite_search_input', function (e) {
        let key = e.which;
        let searchInput = $('div#tag_favorites_list_wrapper input#favorite_search_input');
        // Refresh list if enter was pressed or the search field is empty
        if (key === 13 || $.trim(searchInput.val()) === '') {
            refreshList();
        }
    });

    $(document).on('click', 'div#tag_report_wrapper div#tag_favorites_list_wrapper button#favorite_search_button', function (e) {
        refreshList();
    });


    $(document).on('click', 'div#save_tag_report_favorite_modal button.change-status', function(){
        let currentStatus = $(this).attr('current_status');
        toggleTagReportFavoriteStatus(currentStatus)
    });

    function onReportFetched(dataObj) {
        $('div#tag_report_content').html(dataObj.html);
    }

    function getTranslation(attributeName, fallback) {
        return $('div#tag_report_wrapper').attr(attributeName) || fallback;
    }

    function onError(errorText) {
        displayTailwindAlert(getTranslation('data-error-title', 'An error occurred!'), errorText, 'div#tag_report_content', 'error', 'replace');
    }

    function getTagReport() {
        if (ajaxLockActive) {
            return;
        }
        ajaxLockActive = true;

        let data = getFormData();

        $.ajax({
            type: 'GET',
            url: ajaxPathGetTagReport,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            onReportFetched(data);
        }).error(function (data) {
            onError($.parseJSON(data.responseText).errors);
        }).always(function () {
           ajaxLockActive = false;
        });
    }

    function createExcelFile() {
        if (ajaxLockActive) {
            return;
        }
        ajaxLockActive = true;

        let data = getFormData();

        $.ajax({
            type: 'GET',
            url: excelExportURL,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            window.location = '/includes/report/excels/' + data.excel_file_name;
        }).error(function (data) {
            onError($.parseJSON(data.responseText).errors);
        }).always(function () {
           ajaxLockActive = false;
        });
    }

    function getFormData() {
        return {
            date_from: $('input#date_from').val(),
            date_to: $('input#date_to').val(),
            product_group_tags: getTagSelectValue('select_box_include_product_group_tags'),
            product_tags: getTagSelectValue('select_box_include_product_tags'),
            excluded_product_group_tags: getTagSelectValue('select_box_exclude_product_group_tags'),
            excluded_product_tags: getTagSelectValue('select_box_exclude_product_tags')
        };
    }



    function saveTagReportFavorite() {
        if (ajaxLockActive) {
            return;
        }
        ajaxLockActive = true;

        let tagReportFavoriteId = 0;
        let tagReportFavoriteIdElement = $('div#tag_report_form_wrapper input#tag_report_favorite_id');
        if (tagReportFavoriteIdElement.length) {
            tagReportFavoriteId = tagReportFavoriteIdElement.val() * 1;
        }

        let tagReportFavoriteName = $('input#tag_report_favorite_name').val();
        let productGroupTags = getTagSelectValue('select_box_include_product_group_tags');
        let productTags = getTagSelectValue('select_box_include_product_tags');
        let excludeProductGroupTags = getTagSelectValue('select_box_exclude_product_group_tags');
        let excludeProductTags = getTagSelectValue('select_box_exclude_product_tags');
        let tagReportPeriodSelected = $('select#tag_report_period').val();
        let tagReportEmail = $('input#tag_report_email').val();
        let tagReportEmailCopy = $('input#tag_report_email_copy').val();

        $.ajax({
            type: 'POST',
            url: ajaxPathSaveTagReportFavorite,
            data: {
                'tag_report_favorite_id' : tagReportFavoriteId,
                'tag_report_favorite_name' : tagReportFavoriteName,
                'product_group_tags' : productGroupTags,
                'product_tags' : productTags,
                'excluded_product_group_tags' : excludeProductGroupTags,
                'excluded_product_tags' : excludeProductTags,
                'tag_report_period' : tagReportPeriodSelected,
                'tag_report_email' : tagReportEmail,
                'tag_report_email_copy' : tagReportEmailCopy
            },
            dataType: 'json'
        }).success(function (data) {
            if (data.hasOwnProperty('tag_report_favorite_id') && data.tag_report_favorite_id !== '') {
                getFormWithFavoriteSelected(data.tag_report_favorite_id, true);
            } else {
                getFormWithFavoriteSelected(tagReportFavoriteId, true);
            }

            refreshList();
        }).error(function (data) {
            let errorMessage = $.parseJSON(data.responseText).errors;
            displaySaveErrorMessage(errorMessage);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function getFormWithFavoriteSelected(tagReportFavoriteId, includeSaveSuccessMessage) {
        if (!$.isNumeric(tagReportFavoriteId)) {
            return;
        }

        $.ajax({
            type: 'GET',
            url: ajaxPathGetForm + tagReportFavoriteId,
            dataType: 'json'
        }).success(function (data) {
            $('div#tag_report_form_wrapper').replaceWith(data.html);
            activateTagSelects();
            activateFlatpickr();

            if (includeSaveSuccessMessage) {
                displaySaveSuccessMessage();
            }
        }).error(function () {
            let element = $('div#tag_report_wrapper');
            let errorMessage = getTranslation('data-favorite-load-error', 'Could not load favorite. Please reload the page and try again.');

            displayTailwindAlert(getTranslation('data-error-title', 'An error occurred!'), errorMessage, element, 'error', 'replace');
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function displaySaveSuccessMessage() {
        hideFavoriteModal();
        let element = 'div#tag_report_form_wrapper div#alert_container';
        let successMessage = getTranslation('data-favorite-save-success', 'Favorite saved!');

        displayTailwindAlert('', successMessage, element, 'success', 'replace', true);
    }

    function displaySaveErrorMessage(errorMessage = '') {
        let element = 'div#save_tag_report_favorite_modal div#tag_report_favorite_modal_alert';
        if (errorMessage === '') {
            errorMessage = getTranslation('data-favorite-save-error', 'Could not save favorite, please try again.');
        }

        displayTailwindAlert(getTranslation('data-error-title', 'An error occurred!'), errorMessage, element, 'error', 'replace');
    }

    function activateTagSelects() {
        $('select.tag-report-tag-select').each(function () {
            activateTagTomSelect(this.id, {
                multiple: true
            });
        });
    }

    function refreshList() {

        let path = ajaxPathGetTagReportFavoriteListItems;
        if ($('div#tag_report_wrapper input[name="display_deactivated"]').is(':checked')) {
            path = ajaxPathGetTagReportFavoriteListItems + "?include_deactivated=1";
        }

        let searchString = $.trim($('div#tag_report_wrapper input#favorite_search_input').val());

        $.ajax({
            type: 'GET',
            url: path,
            data: {
                search_string: searchString
            },
            dataType: 'json',
        }).success(function (data) {
            $('div#tag_favorites_list_container').replaceWith(data.html);
        }).error(function (data) {
            let element = $('div#tag_report_wrapper');
            let errorMessage = getTranslation('data-favorite-list-refresh-error', 'Could not update the favorite tag filter list.');

            displayTailwindAlert(getTranslation('data-error-title', 'An error occurred!'), errorMessage, element, 'error', 'replace');
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    /*
	 * Change status of tagReportFavorite
	 * Status = 1: active
	 * Status = 0: deactivated
	 */
    function toggleTagReportFavoriteStatus(currentStatus) {
        // User must confirm deactivation
        if (currentStatus === '1') {
            if (!confirm(getTranslation('data-favorite-deactivate-confirm', 'Do you want to deactivate this favorite? You can reactivate it again at any time.'))) {
                return;
            }
        }

        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        // Set correct action, activate or deactivate
        let tagReportFavoriteId = $('div#tag_report_form_wrapper input#tag_report_favorite_id').val() * 1;
        let action = '';
        if (currentStatus === '1') {
            action = 'deactivate';
        } else {
            action = 'reactivate';
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'PUT',
            url: ajaxPathTagReport + '/favorite/' + tagReportFavoriteId + '/' + action
        }).success(function (data) {
            getFormWithFavoriteSelected(tagReportFavoriteId, true);

            // Update list
            refreshList();

            // Scroll window to the top
            window.scrollTo(0, 0);
        }).error(function () {
            displaySaveErrorMessage(getTranslation('data-favorite-status-error', 'Could not change favorite status. Please reload the page and try again.'));
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function activateFlatpickr() {
        if (typeof flatpickr === 'undefined') {
            return;
        }

        $('div#tag_report_wrapper input.tag-report-flatpickr').each(function () {
            if (this._flatpickr) {
                return;
            }

            flatpickr(this, {
                dateFormat: 'd/m/Y',
                allowInput: false,
                disableMobile: true,
                locale: {
                    firstDayOfWeek: 1
                }
            });
        });
    }

    function activateTagTomSelect(selectId, options) {
        let selectElement = document.getElementById(selectId);
        if (!selectElement || typeof TomSelect !== 'function') {
            return;
        }

        if (selectElement.tomselect) {
            selectElement.tomselect.destroy();
        }

        if (selectElement.disabled) {
            return;
        }

        let tomSelectOptions = {
            create: false,
            persist: false,
            placeholder: selectElement.getAttribute('data-placeholder') || '',
            render: {
                option: function(data, escape) {
                    return renderTagTomSelectEntry(data, escape);
                },
                item: function(data, escape) {
                    return renderTagTomSelectEntry(data, escape);
                }
            }
        };

        if (options.multiple) {
            tomSelectOptions.plugins = ['remove_button'];
            tomSelectOptions.maxItems = null;
        } else {
            tomSelectOptions.plugins = ['dropdown_input'];
            tomSelectOptions.maxItems = 1;
            tomSelectOptions.allowEmptyOption = true;
        }

        new TomSelect(selectElement, tomSelectOptions);
    }

    function renderTagTomSelectEntry(data, escape) {
        let label = escape(data.text || '');
        let color = getTagTomSelectColor(data.color);

        if (color === '') {
            return '<div class="flex items-center"><span>' + label + '</span></div>';
        }

        return '<div class="flex items-center">' +
            '<span class="inline-block h-3 w-3 rounded-full mr-2" style="background-color: ' + color + ';"></span>' +
            '<span>' + label + '</span>' +
            '</div>';
    }

    function getTagTomSelectColor(color) {
        let colorValue = (color || '').toString().trim();
        if (colorValue === '') {
            return '';
        }

        if (/^[#(),.%\sa-zA-Z0-9-]+$/.test(colorValue)) {
            return colorValue;
        }

        return '';
    }

    function getTagSelectValue(selectId) {
        let selectElement = document.getElementById(selectId);
        if (!selectElement) {
            return [];
        }

        if (selectElement.tomselect && typeof selectElement.tomselect.getValue === 'function') {
            let value = selectElement.tomselect.getValue();
            if (Array.isArray(value)) {
                return value;
            }

            return value ? [value] : [];
        }

        let value = $(selectElement).val();
        if (Array.isArray(value)) {
            return value;
        }

        return value ? [value] : [];
    }

    function showFavoriteModal() {
        $('div#save_tag_report_favorite_modal').addClass('show').attr('aria-hidden', 'false');
    }

    function hideFavoriteModal() {
        $('div#save_tag_report_favorite_modal').removeClass('show').attr('aria-hidden', 'true');
    }

});
